import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { ShowMore } from 'src/components/ShowMore';
import styles from './CourseList.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}
export const CourseList: React.FC<Props> = ({ program }) => {
	const courses = program?.contentItems.filter(item => item.category === 'COURSE_OPTION');

	if (courses.length === 0) {
		return null;
	}

	const hasCourseTitle = (title: string) => title && title !== ' ';
	const hasCourseBody = (body: string) => body && body !== ' ';

	return (
		<>
			<Typography className={styles.header} variant='h3'>
				Courses
			</Typography>
			<Typography className={styles.subhead} variant='body2'>
				Some of the courses offered include:
			</Typography>
			<ShowMore section='course_list'>
				<>
					{courses.map(({ category, title, body }) => (
						<div
							className={
								!hasCourseTitle(title) || !hasCourseBody(body)
									? styles.courseContainer
									: styles.courseContainerGrid
							}
							data-testid='program-detail-courses'
							key={`${category}-${title}`}
							role='listitem'
						>
							{hasCourseTitle(title) && (
								<Typography className={styles.courseTitle} variant='label2' weight='bold'>
									{title}
								</Typography>
							)}
							{hasCourseBody(body) && (
								<Typography className={styles.courseBody} variant='body1'>
									{body}
								</Typography>
							)}
						</div>
					))}
				</>
			</ShowMore>
		</>
	);
};
